import React from "react";
import "./Footer.css"

function Footer() {
    return (
      <footer>
        <p>&copy; 2024 Simon Vargas. All rights reserved.</p>
        <p>
       
        </p>
      </footer>
    );
  }

export default Footer